/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultCreateServer } from "../../funcs/llmMcpVaultCreateServer.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateMcpServerRequest$inboundSchema,
};

export const tool$llmMcpVaultCreateServer: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-create-server",
  description: `Create MCP server

Creates a user-owned MCP server configuration. Secret credentials are stored separately.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultCreateServer(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
